import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FEF3C7",
  d: "M0 14C0 6.268 6.268 0 14 0s14 6.268 14 14-6.268 14-14 14S0 21.732 0 14"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D97706",
  d: "M13.977 17.456q-.416 0-.704.256a.89.89 0 0 0-.288.672q0 .4.288.672a.99.99 0 0 0 .704.272q.447 0 .736-.272a.87.87 0 0 0 .304-.672.85.85 0 0 0-.304-.656q-.289-.272-.736-.272m.016-9.616q-.352 0-.544.192-.192.208-.192.56v6.656q0 .352.192.544.192.208.544.208t.544-.208q.192-.193.192-.544V8.592q0-.352-.192-.56-.192-.192-.544-.192"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }